if (!customElements.get('top-glue-finder')) customElements.define('top-glue-finder', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const form = this.querySelector('form');
    const cards = [...this.querySelectorAll('[data-system]')];
    const status = this.querySelector('[data-result-status]');
    const updateFields = () => {
      const led = form.elements.system.value === 'led';
      const beginner = form.elements.experience.value === 'beginner';
      this.querySelector('[data-conditions]').hidden = led;
      this.querySelector('[data-led-note]').hidden = !led;
      this.querySelector('[data-beginner-note]').hidden = !beginner;
      form.elements.humidity.disabled = led;
      form.elements.temperature.disabled = led;
      form.elements.speed.disabled = led;
      form.elements.speed.querySelector('[value="fast"]').disabled = beginner;
      if (beginner) form.elements.speed.value = 'medium';
      status.hidden = true;
      cards.forEach(card => card.hidden = true);
    };
    updateFields();
    form.addEventListener('change', updateFields, {signal});
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const system = form.elements.system.value;
      const h = Number(form.elements.humidity.value);
      const t = Number(form.elements.temperature.value);
      const speed = form.elements.speed.value;
      const beginner = form.elements.experience.value === 'beginner';
      let count = 0;
      cards.forEach(card => {
        const d = card.dataset;
        const experienceMatches = !beginner || +d.smin > 0.5;
        const speedMatches = beginner || (speed === 'fast' ? +d.smax <= 1 : +d.smax > 1);
        const matches = experienceMatches && d.system === system && (system === 'led' || (h >= +d.hmin && h <= +d.hmax && t >= +d.tmin && t <= +d.tmax && speedMatches));
        card.hidden = !matches;
        if(matches) count++;
      });
      status.textContent = count ? status.dataset.match : status.dataset.empty;
      status.hidden = false;
    }, {signal});
  }
  disconnectedCallback() {this.controller?.abort();}
});
